import React from "react";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import { formattedDate } from "../../../../Common/helper/helpar";

export const MSWManagementVehiclesExport = ({ fromDate, toDate }) => {
  const { MSWManagementSecondaryCollectionReportData } =
    MSWManagementSecondaryCollectionStore();

  // Table date format: DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Timestamp format with time for "Generated On"
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };
  const currentDateTime = formatDateTime(new Date());

  const downloadAsExcel = async () => {
    if (!MSWManagementSecondaryCollectionReportData || MSWManagementSecondaryCollectionReportData.length === 0) {
      alert("No data available to export. Please apply filters and try again.");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("MSW Vehicles On Road Report");

    const boldFont = { bold: true };

    // Row 1 - Generated On
    worksheet.addRow([`MSW Management Vehicles On The Road - Secondary Collection Report Generated On: ${currentDateTime}`]);
    worksheet.mergeCells(1, 1, 1, 6);
    worksheet.getCell(1, 1).font = boldFont;
    worksheet.getCell(1, 1).alignment = { horizontal: "center" };

    // Row 2 - Title with filter dates
    worksheet.addRow([
      `MSW Management Vehicles On The Road - Secondary Collection Report as on ${formattedDate(fromDate)} to ${formattedDate(toDate)}`
    ]);
    worksheet.mergeCells(2, 1, 2, 6);
    worksheet.getCell(2, 1).font = boldFont;
    worksheet.getCell(2, 1).alignment = { horizontal: "center" };

    worksheet.addRow([]); // Empty row for spacing

    // Table header
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Date",
      "Total Number Of Vehicles Planned For Deployment (a)",
      "Total Number Of Vehicles Deployed (b)",
      "Performance Achieved",
      "Remarks",
    ]);

    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "center", wrapText: true, vertical: "middle" };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6B1B1" } };
    });

    // Table data
    MSWManagementSecondaryCollectionReportData.forEach((row, index) => {
      const isTotalRow = row.reportDate === "Total";
      const rowData = [
        isTotalRow ? "" : index + 1,
        isTotalRow ? "Total" : formatDate(row.reportDate),
        row.plannedVehicleCount ?? 0,
        row.deployedVehicleCount ?? 0,
        isTotalRow ? "" : row.performanceAchieved ?? 0,
        row.remarks ?? "N/A",
      ];
      const dataRow = worksheet.addRow(rowData);
      dataRow.eachCell((cell) => {
        cell.alignment = { horizontal: "center" };
        if (isTotalRow) cell.font = boldFont;
      });
    });

    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 35 },
      { width: 35 },
      { width: 25 },
      { width: 30 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "MSW_Vehicles_On_Road_Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadAsPDF = () => {
  const reportTitle = `MSW Management Vehicles On The Road - Secondary Collection Report as on ${formattedDate(fromDate)} to ${formattedDate(toDate)}`;
  const topHeaderText = `MSW Management Vehicles On The Road - Secondary Collection Report is generated on (${currentDateTime})`;

    const styledText = (text, x, y, size, options = {}) => {
        const originalSize = doc.getFontSize();
        doc.setFontSize(size);
        doc.text(text, x, y, options);
        doc.setFontSize(originalSize); // Reverts back automatically
    };


    const doc = new jsPDF("l", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    // const currentDateTime = formatDateTime(new Date());

   

    // Title with filter dates
    const titleX = pageWidth / 2;
    styledText(topHeaderText, titleX, 15, 12, { align: "center" });
    styledText(reportTitle, titleX, 24, 14, { align: "center" });

    const tableColumn = [
      "S.No",
      "Date",
      "Total Number Of Vehicles Planned For Deployment (a)",
      "Total Number Of Vehicles Deployed (b)",
      "Performance Achieved",
      "Remarks",
    ];

    const tableRows = MSWManagementSecondaryCollectionReportData.map((row, index) => {
      const isTotalRow = row.reportDate === "Total";
      return [
        isTotalRow ? "" : index + 1,
        isTotalRow ? "Total" : formatDate(row.reportDate),
        row.plannedVehicleCount ?? 0,
        row.deployedVehicleCount ?? 0,
        isTotalRow ? "" : row.performanceAchieved ?? 0,
        row.remarks ?? "",
      ];
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 28,
      theme: "grid",
      headStyles: { fillColor: [0, 102, 204], textColor: [255, 255, 255], fontStyle: "bold" },
      styles: { halign: "center" },
      didParseCell: (data) => {
        if (data.row.raw[1] === "Total") {
          Object.values(data.row.cells).forEach((cell) => {
            cell.styles.fontStyle = "bold";
          });
        }
      },
    });

    doc.save("MSW_Vehicles_On_Road_Report.pdf");
  };

  return (
    <>
      <button className="btn btn-excel me-2" onClick={downloadAsPDF}>
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
    </>
  );
};
